module.exports = __webpack_public_path__ + "img/offlineicon.27a25904.png";